import { AgileTaskIcon, BugIcon, EpicIcon, UserStoryIcon } from '@sketchnote/icons';
import { Node } from 'slate';
import { getFormattedValue } from 'src/utils/getFormattedValue';

import { useAgileStore } from '../../store';

export const typeOptions = [
  { id: '1', color: '#FFA8A8', name: 'Story', icon: <UserStoryIcon />, type: 'story' },
  { id: '2', color: '#A8D0FF', name: 'Bug', icon: <BugIcon />, type: 'bug' },
  { id: '3', color: '#C4C4C4', name: 'Task', icon: <AgileTaskIcon />, type: 'task' },
  { id: '4', color: '#FD9740', name: 'Epic', icon: <EpicIcon />, type: 'epic' },
];

export const StatusColors = {
  not_started: '#E2E4E9',
  in_progress: '#DBEAFE',
  completed: '#D1FAE5',
};

export const StatusRenderer = ({ data, value }: { data: any; value?: string }) => {
  const columns = useAgileStore((s) => s.columns);
  const statusColumn = columns.find((col) => col._id === value);
  if (!statusColumn) return null;
  return (
    <div
      className="rounded-sm h-full w-full text-center"
      style={{ backgroundColor: StatusColors[statusColumn.type] }}
    >
      {statusColumn.name}
    </div>
  );
};

export const TypeRenderer = ({ data, value }: { data: any; value: string }) => {
  const type = typeOptions.find((option) => option.type === value);
  if (!type) return null;
  return (
    <div className=" flex items-center h-full">
      <span className="mr-8 block">{type.icon}</span>
      <span className="text-sm block  font-medium">
        {type.name[0].toUpperCase() + type.name.substring(1)}
      </span>
    </div>
  );
};

export const EpicCellRenderer = ({ data, value }: { data: any; value: string }) => {
  const epics = useAgileStore((s) => s.epics);
  const epic = epics.find((epic) => epic._id === value);
  if (!epic) return null;
  return (
    <div className=" flex items-center h-full">
      <span className="leading-10 px-6 py-4 text-xs font-semibold rounded-sm block mr-4 max-w-185 truncate">
        {getFormattedValue(epic.name)}
      </span>
    </div>
  );
};
